import React from 'react';
import LegalDocumentLayout from '../../components/legal/LegalDocumentLayout';
import { getLegalPage } from '../../content/legal/legalPages';

function TermsOfUsePage() {
  const page = getLegalPage('terms-of-use');
  return <LegalDocumentLayout page={page} />;
}

export default TermsOfUsePage;
